<template>
  <div>
    <el-select :value="status" value-key="key" :size="size" :placeholder="$t('table.status')" @input="change($event)" :clearable="true">
      <el-option label="未处理" value="0" />
      <el-option label="已处理" value="1" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: ''
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.status = val
      this.$emit('input', this.status)
    }
  },
  mounted () {
    if (this.value) {
      this.status = '' + (this.value)
    }
  },
  watch: {
    value: function (val, oldVal) {
      this.status = '' + (val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/ProgressStatusSelect.vue